import styled from 'styled-components';

export default styled.span`
    color: ${({ theme }) => theme.colors.red90};
    font-size: 12px;
    a {
        color: ${({ theme }) => theme.colors.red90};
    }
`;
